import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { VisitorProvider, useVisitor } from './context/VisitorContext';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Visitors from './pages/Visitors';
import Projects from './pages/Projects';
import Settings from './pages/Settings';
import EmbedScript from './pages/EmbedScript';
import Blacklist from './pages/Blacklist';
import Toast from './common/Toast';

const AppContent = () => {
  const { toast, setToast } = useVisitor();
  const location = useLocation();

  return (
    <div className="flex min-h-screen bg-gray-50 text-slate-900 font-sans">
      <Sidebar />
      <div className="ml-64 flex-1">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/visitors" element={<Visitors />} />
            <Route path="/blacklist" element={<Blacklist />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/embed" element={<EmbedScript />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </AnimatePresence>
      </div>
      <AnimatePresence>
        {toast && (
          <Toast
            message={toast.message}
            type={toast.type}
            onClose={() => setToast(null)}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

function App() {
  return (
    <Router>
      <VisitorProvider>
        <AppContent />
      </VisitorProvider>
    </Router>
  );
}

export default App;